/**
 * Ataco Client Configuration
 * Overrides default configuration for Ataco client
 */

import { defaultConfig } from './default';

export const atacoConfig = {
  ...defaultConfig,

  clientId: 'ataco',
  clientName: 'Ataco',

  localization: {
    ...defaultConfig.localization,
    languages: ['bs', 'en'],
  },

  orderQuantity: {
    ...defaultConfig.orderQuantity,
    integerOnlyOrderTypeCodes: ['10', '12', '20'],
    respectProductDecimalFlag: false,
  },

  productPricing: {
    ...defaultConfig.productPricing,
    displayOnlyOutOfStockPrice: true,
  },

  customers: {
    ...defaultConfig.customers,
    fetchDiscounts: true,
    routeLookupMode: 'superior',
  },

  tasks: {
    ...defaultConfig.tasks,
    defaultCategoryId: '597899',
  },

  orders: {
    ...defaultConfig.orders,
    showDocumentTypeReport: true,
  },

  tobacco: {
    ...defaultConfig.tobacco,
    enabled: true,
  },

  monitoring: {
    ...defaultConfig.monitoring,
    networkDetailAllowUrls: [
      ...defaultConfig.monitoring.networkDetailAllowUrls,
      '^https://.*\\.ataco-bih\\.com',
    ],
    tracePropagationTargets: [
      ...defaultConfig.monitoring.tracePropagationTargets,
      '^https://(?!cms\\.).*\\.ataco-bih\\.com',
    ],
  },

  features: {
    ...defaultConfig.features,
    showR1Discount: false,
  },
};

export default atacoConfig;
